<div>
    <div class="ml-auto w-full text-right justify-end -mt-4 -mr-3">
        <button id="closeModalChangeStatus2" mat-icon-button (click)="closeModal()" tabindex="-1">
            <mat-icon class="close-x-primary">close</mat-icon>
        </button>
    </div>

    <div class="pb-2 text-xl w-3/4 candidate-title">
        {{ 'messagerChatTitle' | translate }}
    </div>

    <div class="flex items-center gap-4 pb-2">
        <!-- Foto perfil -->
        <div class="flex">
            <div class="w-14 h-14 relative">
                <!-- Borde redondo externo -->
                <div class="w-14 h-14 absolute rounded-full border image-container z-10"></div>
                <!-- Imagen del perfil del usuario -->
                <img *ngIf="userImage" class="w-14 h-14 absolute rounded-full object-cover" [src]="userImage" alt="">
                <img *ngIf="!userImage" class="w-14 h-14 absolute rounded-full object-cover" [src]="defaultpfp" alt="">

                <!-- Icono de whatsapp -->
                <div class="w-6 h-6 absolute -bottom-1 -right-1 rounded-full border image-container z-10">
                    <img [src]="whatsIcon" alt="WhatsApp" class="w-6 h-6 absolute rounded-full object-cover">
                </div>
            </div>
        </div>
        <!-- Foto perfil END -->

        <div class="flex flex-col justify-center w-full">
            <div class="text-xl w-3/4 candidate-name">
                <a *ngIf="candidate" [routerLink]="['/home/candidatedetail']" [queryParams]="{ id: candidate.cdT_ID }"
                    (click)="closeModal()">
                    {{candidate.cdT_NAME}} {{candidate.cdT_PATERNAL_SURNAME}} {{candidate.cdT_MATERNAL_SURNAME}}
                </a>
            </div>

            <div class="text-xl w-full candidate-job flex justify-between items-center mt-0.5">
                <div>
                    <span class="block mb-0.5" *ngIf="candidate">{{candidate.cdT_JOB_INFO.joB_NAME | translate}}</span>
                    <span class="block" *ngIf="candidateNumber">
                        {{candidateNumber}}
                    </span>
                </div>
                <div *ngIf="!isMini; else miniCV">
                    <ng-container *ngIf="candidate.cv && candidate.cv.cdoC_ACTIVE; else noCv">
                        <img id="openCvMessageChat" [src]="cvLogo" class="cursor-pointer action-icons"
                            (click)="openCv()" [matTooltip]="'candidateSeeCV' | translate:{name: candidate.cdT_NAME}">
                    </ng-container>
                    <ng-template #noCv>
                        <div
                            class="icon-container cv-link-container ml-4 flex items-center justify-center option-hover-effect">
                            <a id="closeAndNavigateCandidate" routerLink="/home/candidatedetail"
                                [queryParams]="{id: candidate.cdT_ID, select: 'button2', docType: 'CV'}"
                                [matTooltip]="'candidateAddCV' | translate:{name: candidate.cdT_NAME}"
                                (click)="closeAndNavigate()">
                                <img [src]="nocvLogo" class="cursor-pointer action-icons">
                            </a>
                        </div>
                    </ng-template>
                </div>

                <ng-template #miniCV>
                    <div *ngIf="((candidate?.cv?.cdoC_ACTIVE && (!getPermission('X01') || !showCVClient)) || candidate?.candidateCVClient?.clienT_CDOC_ACTIVE || candidate?.candidateReportDocument?.reporT_CDOC_ACTIVE); else noCVMini"
                        class="icon-container cv-link-container ml-3 flex items-center justify-center option-hover-effect">
                        <a id="openCvCandidateDetail" [matMenuTriggerFor]="cvOptions">
                            <img [src]="cvLogo" class="cursor-pointer action-icons">
                        </a>
                    </div>
                    <ng-template #noCVMini>
                        <div class="icon-container cv-link-container ml-3 flex items-center justify-center">
                            <a *ngIf="getPermission('X01')" id="openNoCvCandidateDetail">
                                <img [src]="nocvLogo" class="cursor-default action-icons">
                            </a>
                            <a *ngIf="!getPermission('X01')" id="openCvCandidateDetail" [matMenuTriggerFor]="cvOptions">
                                <img [src]="nocvLogo" class="cursor-pointer action-icons">
                            </a>
                        </div>
                    </ng-template>
                </ng-template>

                <mat-menu #cvOptions="matMenu">
                    <!-- CV Normal -->
                    <div *ngIf="candidate.cv && candidate.cv.cdoC_ACTIVE && (!getPermission('X01') || !showCVClient)"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        (click)="opendoc(candidate, 3, 0)">
                        <div id="candidateSeeCV" class="flex items-center justify-around cursor-pointer">
                            <img [src]="cvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ 'candidateSeeCV2' | translate }}
                            </div>
                        </div>
                    </div>
                    <a *ngIf="(!candidate.cv || !candidate.cv.cdoC_ACTIVE) && (!getPermission('X01') || !showCVClient)"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        routerLink="/home/candidatedetail"
                        [queryParams]="{id: candidate.cdT_ID, select: 'button2', docType: 'CV'}"
                        (click)="closeAndNavigate()">
                        <div id="candidateAddCV" class="flex items-center justify-around cursor-pointer">
                            <img [src]="nocvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ 'candidateAddCV2' | translate }}
                            </div>
                        </div>
                    </a>

                    <!-- CV Clientes -->
                    <div *ngIf="showCVClient && candidate.candidateCVClient && candidate.candidateCVClient.clienT_CDOC_ACTIVE"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        (click)="opendoc(candidate, 3, 1)">
                        <div id="candidateSeeCVClients" class="flex items-center justify-around cursor-pointer">
                            <img [src]="cvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ getPermission('X01') ? ('candidateSeeCV2' | translate) : ('candidateSeeCVClients' |
                                translate) }}
                            </div>
                        </div>
                    </div>
                    <a *ngIf="showCVClient && (!candidate.candidateCVClient || !candidate.candidateCVClient.clienT_CDOC_ACTIVE) && !getPermission('X01')"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        routerLink="/home/candidatedetail"
                        [queryParams]="{id: candidate.cdT_ID, select: 'button2', docType: 'CV_CLIENTS'}"
                        (click)="closeAndNavigate()">
                        <div id="candidateAddCVClients" class="flex items-center justify-around cursor-pointer">
                            <img [src]="nocvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ 'candidateAddCVClients' | translate }}
                            </div>
                        </div>
                    </a>

                    <!-- Reporte de candidato -->
                    <div *ngIf="candidate.candidateReportDocument && candidate.candidateReportDocument.reporT_CDOC_ACTIVE"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        (click)="opendoc(candidate, 3, 2)">
                        <div id="candidateSeeCDReport" class="flex items-center justify-around cursor-pointer">
                            <img [src]="cvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ 'candidateSeeCDReport' | translate }}
                            </div>
                        </div>
                    </div>
                    <a *ngIf="(!candidate.candidateReportDocument || !candidate.candidateReportDocument.reporT_CDOC_ACTIVE) && !getPermission('X01')"
                        class="flex items-center justify-start px-1  py-1 w-full option-hover-effect cursor-pointer"
                        routerLink="/home/candidatedetail"
                        [queryParams]="{id: candidate.cdT_ID, select: 'button2', docType: 'CANDIDATE_REPORT'}"
                        (click)="closeAndNavigate()">
                        <div id="candidateAddCDReport" class="flex items-center justify-around cursor-pointer">
                            <img [src]="nocvLogo" class="cursor-pointer action-icons">
                            <div class="px-2 actions-text md:flex">
                                {{ 'candidateAddCDReport' | translate }}
                            </div>
                        </div>
                    </a>
                </mat-menu>
            </div>
            <!--     <div class="pb-2 text-xl w-1/4 text-right">
          N°: <span *ngIf="candidate">{{candidate.cdT_NUMBER}}</span>
        </div> -->
        </div>
    </div>


    <div *ngIf="templatesActive; else noTemplates"
        class="h-60p my-4 border-t border-gray-200 overflow-y-auto py-4 space-y-4 px-2">
        <span class="text-base text-gray-500 font-medium block mb-6">{{ 'messagerChatTemplates' | translate }}</span>

        <div class="w-full">
            <div class="flex flex-row justify-end mt-4" *ngFor="let message of messageTemplates">
                <div class="flex flex-col items-end max-w-34">
                    <div class="bg-l-green text-gray-800 p-3 rounded-t-lg rounded-l-lg text-base shadow whitespace-pre-wrap cursor-pointer template-message"
                        (click)="sendTemplate(message)">
                        {{ getTemplateName(message) }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full" *ngIf="templatesActive && messageList?.length > 0">
        <div class="w-fit mx-auto cursor-pointer text-center text-white bg-primary  rounded-lg flex items-center justify-center py-3 px-5 text-base font-medium hover:bg-yellow-700"
            (click)="viewWspChatHistory()">
            {{ 'viewWspChatHistory' | translate }}
        </div>
    </div>

    <ng-template #noTemplates>
        <div *ngIf="!selectedFileName"
            class="h-60p my-4 border-t border-b border-gray-200 overflow-y-auto py-4 space-y-4 px-2 scroll-container"
            #scrollContainer (scroll)="onScroll($event)">
            <!-- Mensajes ordenados con los más recientes abajo -->
            <div class="flex flex-col">
                <div *ngFor="let message of messageList.slice().reverse()" class="w-full">
                    <div *ngIf="message.sender === 'company'" class="w-full">
                        <div class="w-full mb-4">
                            <!-- Mensaje del reclutador -->
                            <div class="flex flex-row justify-end"
                                *ngIf="message.msG_TYPE === 'text' && message.msG_TEXT">
                                <div class="flex flex-col items-end max-w-34 overflow-hidden">
                                    <div class="w-full bg-l-green text-gray-800 p-3 rounded-t-lg rounded-l-lg text-base shadow whitespace-pre-wrap"
                                        [innerHTML]="inyectUrlLinks(message.msG_TEXT)">
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-end font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Imagen adjunta reclutador -->
                            <div class="flex flex-row justify-end"
                                *ngIf="(message.msG_TYPE === 'image' || message.msG_TYPE === 'sticker') && message.mediA_ID">
                                <div class="flex flex-col items-end max-w-34 max-h-34">
                                    <div class="w-fit h-full bg-l-green text-gray-800 p-1.5 rounded-t-xl rounded-l-xl text-sm shadow flex items-center cursor-pointer"
                                        (click)="openImage(getImageUrl(message.mediA_ID))">
                                        <img [src]="getImageUrl(message.mediA_ID)" alt="Imagen adjunta"
                                            class="h-image rounded-t-lg rounded-l-lg">
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-end font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Archivo adjunto reclutador -->
                            <div class="flex flex-row justify-end"
                                *ngIf="message.msG_TYPE === 'document' && message.mediA_ID">
                                <div class="flex flex-col items-end max-w-34">
                                    <div class="bg-l-green text-gray-800 p-3 rounded-t-lg rounded-l-lg text-sm shadow flex items-center space-x-2 cursor-pointer"
                                        (click)="openImage(getImageUrl(message.mediA_ID))">
                                        <mat-icon *ngIf="!isPdf(message.msG_TEXT)" class="w-6 h-6 flex-shrink-0">
                                            description
                                        </mat-icon>
                                        <mat-icon *ngIf="isPdf(message.msG_TEXT)" class="w-6 h-6 flex-shrink-0">
                                            picture_as_pdf
                                        </mat-icon>
                                        <div class="flex-1 overflow-hidden">
                                            <div *ngIf="message.msG_TEXT" class="break-words pr-2">{{message.msG_TEXT}}
                                            </div>
                                            <div *ngIf="!message.msG_TEXT" class="break-words pr-2">
                                                Untitled Document
                                            </div>
                                        </div>
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-end font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="message.sender === 'candidate'" class="w-full">
                        <div class="w-full mb-4">
                            <!-- Mensaje del candidato -->
                            <div class="flex flex-row justify-start"
                                *ngIf="message.msG_TYPE === 'text' && message.msG_TEXT">
                                <div class="flex flex-col items-start max-w-34 overflow-hidden">
                                    <div class="w-full bg-d-green text-white p-3 rounded-t-lg rounded-r-lg text-base shadow whitespace-pre-wrap overflow-hidden"
                                        [innerHTML]="inyectUrlLinks(message.msG_TEXT)">
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Imagen adjunta candidato -->
                            <div class="flex flex-row justify-start"
                                *ngIf="(message.msG_TYPE === 'image' || message.msG_TYPE === 'sticker') && message.mediA_ID">
                                <div class="flex flex-col max-w-34">
                                    <div class="max-h-34 w-fit bg-d-green text-white p-1.5 rounded-t-xl rounded-r-xl text-sm shadow flex items-center cursor-pointer"
                                        (click)="openImage(getImageUrl(message.mediA_ID))">
                                        <img [src]="getImageUrl(message.mediA_ID)" alt="Imagen adjunta"
                                            class="h-image rounded-t-lg rounded-r-lg block">
                                    </div>
                                    <div *ngIf="message.msG_TEXT"
                                        class="mt-2 w-fit bg-d-green p-1.5 rounded-t-xl rounded-r-xl">
                                        <div class="text-base text-white self-start"
                                            [innerHTML]="inyectUrlLinks(message.msG_TEXT)">
                                        </div>
                                    </div>
                                    <span class="block text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Archivo adjunto candidato -->
                            <div class="flex flex-row justify-start"
                                *ngIf="message.msG_TYPE === 'document' && message.mediA_ID">
                                <div class="flex flex-col max-w-34">
                                    <div class="bg-d-green text-white p-3 rounded-t-lg rounded-r-lg text-sm shadow flex items-center space-x-2 cursor-pointer"
                                        (click)="openImage(getImageUrl(message.mediA_ID), getDocumentName(message.msG_TEXT))">
                                        <mat-icon *ngIf="!isPdf(message.msG_TEXT)" class="w-6 h-6 flex-shrink-0">
                                            description
                                        </mat-icon>
                                        <mat-icon *ngIf="isPdf(message.msG_TEXT)" class="w-6 h-6 flex-shrink-0">
                                            picture_as_pdf
                                        </mat-icon>
                                        <div class="flex-1 overflow-hidden">
                                            <div *ngIf="getDocumentName(message.msG_TEXT)" class="break-words pr-2">
                                                {{getDocumentName(message.msG_TEXT)}}
                                            </div>
                                            <div *ngIf="!getDocumentName(message.msG_TEXT)" class="break-words pr-2">
                                                Untitled Document
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="getDocumentText(message.msG_TEXT)"
                                        class="mt-2 w-fit bg-d-green p-1.5 rounded-t-xl rounded-r-xl">
                                        <div class="text-base text-white self-start"
                                            [innerHTML]="inyectUrlLinks(getDocumentText(message.msG_TEXT))">
                                        </div>
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Location -->
                            <div class="flex flex-row justify-start"
                                *ngIf="message.msG_TYPE === 'location' && message.latitude && message.longitude">
                                <div class="flex flex-col max-w-34">
                                    <div class="bg-d-green text-white p-1.5 rounded-t-xl rounded-r-xl text-sm shadow cursor-pointer"
                                        (click)="openLocation(message.latitude, message.longitude)">
                                        <div class="map-container">
                                            <img [src]="getStaticMapUrl(message.latitude, message.longitude)"
                                                alt="Ubicación" class="w-full h-[150px] object-cover rounded-lg" />
                                        </div>
                                        <div class="p-2 text-center">
                                            <mat-icon class="align-middle mr-1">location_on</mat-icon>
                                            <span>Ver ubicación</span>
                                        </div>
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Audio -->
                            <div class="flex flex-row justify-start"
                                *ngIf="message.msG_TYPE === 'audio' && message.mediA_ID">
                                <div class="flex flex-col w-3/4">
                                    <div class="bg-d-green text-white p-3 rounded-t-lg rounded-r-lg text-sm shadow">
                                        <div class="flex items-center w-full">
                                            <div
                                                class="bg-l-green rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0">
                                                <mat-icon class="color-d-green">mic</mat-icon>
                                            </div>
                                            <button mat-icon-button (click)="toggleAudio(message.mediA_ID)"
                                                class="text-white flex-shrink-0">
                                                <mat-icon>{{ isPlaying(message.mediA_ID) ? 'pause' : 'play_arrow'
                                                    }}</mat-icon>
                                            </button>
                                            <div class="flex-1 w-full ml-2">
                                                <div
                                                    class="w-full bg-white bg-opacity-20 rounded-full h-1 cursor-pointer">
                                                    <div class="bg-white h-1 rounded-full transition-all duration-300"
                                                        [style.width.%]="getAudioProgress(message.mediA_ID)"></div>
                                                </div>
                                            </div>
                                            <span class="text-xs text-white text-opacity-80 ml-2">{{
                                                getAudioDuration(message.mediA_ID) }}</span>
                                        </div>
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                            <!-- Video -->
                            <div class="flex flex-row justify-start"
                                *ngIf="message.msG_TYPE === 'video' && message.mediA_ID">
                                <div class="flex flex-col max-w-34">
                                    <div
                                        class="w-fit max-h-34 bg-d-green text-white p-3 rounded-t-lg rounded-r-lg text-sm shadow">
                                        <video [src]="getImageUrl(message.mediA_ID)" class="w-full h-full rounded-lg"
                                            controls></video>
                                    </div>
                                    <div *ngIf="message.msG_TEXT"
                                        class="mt-2 w-fit bg-d-green p-1.5 rounded-t-xl rounded-r-xl">
                                        <div class="text-base text-white self-start"
                                            [innerHTML]="inyectUrlLinks(message.msG_TEXT)">
                                        </div>
                                    </div>
                                    <span class="text-sm text-gray-400 mt-2 self-start font-medium">
                                        {{message.timestamp | date: 'dd/MM/yy h:mm a'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Indicador de carga para infinite scroll -->
            <div *ngIf="isLoadingMoreMessages" class="text-center py-2">
                <mat-spinner diameter="30" class="mx-auto"></mat-spinner>
            </div>
        </div>

        <!-- Ícono de archivo seleccionado -->
        <div *ngIf="selectedFileName"
            class="w-full h-60p my-4 border-t border-b border-gray-200 flex items-center justify-center bg-dark-t relative">
            <div class="w-full h-full file-indicator flex flex-col items-center justify-center">

                <div *ngIf="selectedFileType === 'image'" class="block h-3/4">
                    <img [src]="selectedFileUrl" alt="Imagen seleccionada"
                        class="w-auto h-full rounded-lg object-contain">
                </div>
                <div *ngIf="selectedFileType !== 'image'"
                    class="w-full flex flex-col items-center justify-center gap-4 pdf-container">
                    <mat-icon class="block pdf-icon">picture_as_pdf</mat-icon>
                    <span class="block">{{ selectedFileName }}</span>
                </div>
            </div>

            <!-- Ícono de cancelar archivo -->
            <div class="absolute top-3 right-3 cursor-pointer" (click)="removeSelectedFile($event)"
                [matTooltip]="'messagerChatRemoveFile' | translate">
                <mat-icon class="text-black">close</mat-icon>
            </div>
        </div>
    </ng-template>

    <!-- Formulario de envío de mensaje -->
    <div *ngIf="!templatesActive" class="flex items-center pt-2"
        [matTooltip]="blockedInput ? (blockedReason | translate) : ''"
        [class]="showChatHistory ? 'cursor-pointer' : 'cursor-default'"
        (click)="showChatHistory ? hideWspChatHistory() : ''">
        <!-- Botón para subir archivos -->
        <div>
            <button *ngIf="!selectedFileName && blockedInput" class="center-icon text-gray-400 mx-2"
                [class]="showChatHistory ? 'cursor-pointer' : 'cursor-default'">
                <mat-icon>attach_file</mat-icon>
            </button>

            <button *ngIf="!selectedFileName && !blockedInput" mat-icon-button [matMenuTriggerFor]="fileMenu"
                class="center-icon color-d-green">
                <mat-icon>attach_file</mat-icon>
            </button>


            <mat-menu #fileMenu="matMenu">
                <button mat-menu-item (click)="onFileSelect('image')" class="flex items-center gap-2">
                    <mat-icon>image</mat-icon>
                    <span class="select-file">{{ 'messagerChatImage' | translate }}</span>
                </button>
                <button mat-menu-item (click)="onFileSelect('pdf')" class="flex items-center gap-2">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span class="select-file">{{ 'messagerChatPDF' | translate }}</span>
                </button>
            </mat-menu>
        </div>

        <!-- Campo de texto para escribir un mensaje -->
        <div class="w-full relative flex items-center" [class]="showChatHistory ? 'cursor-pointer' : 'cursor-default'">
            <div class="flex flex-col w-full relative">
                <textarea placeholder="Escribe un mensaje" [(ngModel)]="message"
                    class="w-full min-h-48 max-h-28 resize-none p-2 px-4 pr-10 rounded-3xl border border-gray-300 focus:outline-none focus:ring-1 focus:ring-l-green overflow-auto scrollbar-hide text-base"
                    rows="1" (input)="adjustTextareaHeight($event)" (keydown)="onKeyDown($event)" maxlength="4000"
                    [disabled]="blockedInput" [class]="showChatHistory ? 'cursor-pointer' : 'cursor-default'"
                    (click)="!blockedInput && showChatHistory ? hideWspChatHistory() : ''" tabindex="1"></textarea>
                <!-- Div transparente que captura clicks cuando el textarea está deshabilitado -->
                <div *ngIf="blockedInput && showChatHistory" class="absolute inset-0 cursor-pointer z-10"
                    (click)="hideWspChatHistory()"></div>
            </div>

            <!-- Botón emojis -->
            <mat-icon *ngIf="blockedInput" #emojiButton
                class="text-gray-400 absolute bottom-1/2 right-3 transform translate-y-1/2">insert_emoticon</mat-icon>
            <mat-icon *ngIf="!blockedInput" #emojiButton
                class="color-d-green absolute bottom-1/2 right-3 transform translate-y-1/2 cursor-pointer"
                (click)="toggleEmojiPicker($event)">insert_emoticon</mat-icon>
            <!-- Panel de emojis -->
            <div #emojiPanel *ngIf="showEmojiPicker"
                class="fixed bottom-4 right-4 z-50 md:absolute md:bottom-14 md:right-0 md:left-auto">
                <div class="max-w-full mx-auto md:max-w-none">
                    <emoji-mart (emojiClick)="onEmojiSelected($event)" [showPreview]="false" [darkMode]="false" [i18n]="{ search: ('emojiSearch' | translate), 
                              categories: {
                                recent: ('emojiRecent' | translate),
                                smileys: ('emojiSmileys' | translate),
                                people: ('emojiPeople' | translate),
                                nature: ('emojiNature' | translate),
                                foods: ('emojiFoods' | translate),
                                activity: ('emojiActivity' | translate),
                                places: ('emojiPlaces' | translate),
                                objects: ('emojiObjects' | translate),
                                symbols: ('emojiSymbols' | translate),
                                flags: ('emojiFlags' | translate)
                              }
                            }">
                    </emoji-mart>
                </div>
            </div>
        </div>

        <!-- Botón para enviar un mensaje -->
        <button *ngIf="!blockedInput"
            class="ml-3 bg-l-green rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0"
            (click)="sendMessage()">
            <mat-icon class="color-d-green">send</mat-icon>
        </button>
        <button *ngIf="blockedInput"
            class="ml-3 bg-gray-400 rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0"
            [class]="showChatHistory ? 'cursor-pointer' : 'cursor-default'">
            <mat-icon class="text-gray-600">send</mat-icon>
        </button>
    </div>

    <input type="file" #imageFileInput accept="image/*" (change)="onFileChange($event)" style="display: none;" />

    <!-- Input para seleccionar PDFs -->
    <input type="file" #pdfFileInput accept=".pdf" (change)="onFileChange($event)" style="display: none;" />
</div>